import {Box, Stack, Typography} from "@mui/material";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import {ActionButton} from "../shared/ui/ActionButton";
import {useRef} from "react";
import {useAppSelector} from "../app/store/hooks";
import {encodeImageToBase64} from "../utils/encodeImageToBase64";

interface UploadPhotoWidgetProps {
    onPhotoSelected: (base64: string) => void;
}

export const UploadPhotoWidget = ({onPhotoSelected}: UploadPhotoWidgetProps) => {
    const platform = useAppSelector((state) => state.app.platform) || 'unknown';
    const fileInputRef = useRef<HTMLInputElement>(null);
    const cameraInputRef = useRef<HTMLInputElement>(null);

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            try {
                const base64 = await encodeImageToBase64(file);
                onPhotoSelected(base64);
            } catch (error) {
                console.error('Failed to encode image:', error);
            }
        }
    };

    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    const handleCameraClick = () => {
        cameraInputRef.current?.click();
    };

    return (
        <Box sx={{padding: '24px 16px'}}>
            <Typography variant="h6" sx={{textAlign: 'center', marginBottom: '24px'}}>
                Upload your photo
            </Typography>
            <Stack direction="column" spacing={2} padding={'16px 0'} justifyContent={'center'} alignItems={'center'}>
                <ActionButton
                    icon={<FileUploadOutlinedIcon sx={{fontSize: 32}}/>}
                    label="Upload"
                    onClick={handleUploadClick}

                />
                {platform === 'ios' && (
                    <ActionButton
                        icon={<CameraAltOutlinedIcon sx={{fontSize: 32}}/>}
                        label="Take Photo"
                        onClick={handleCameraClick}
                    />
                )}
            </Stack>
            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                style={{display: 'none'}}
                onChange={handleFileChange}
            />
            {platform === 'ios' && (
                <input
                    ref={cameraInputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{display: 'none'}}
                    onChange={handleFileChange}
                />
            )}
        </Box>
    );
};
